@if (loading) {
<div class="container">
    @if (loading) {
    <rask-busy-spinner size="1"></rask-busy-spinner>
    }&nbsp;Laddar Field Maps...
</div>
}
@if (!loading) {
<div class="container">
    <rask-header [uppercase]="false" size="4">Importkälla</rask-header>

    @if (loading) {
    <div>
        @if (loading) {
        <rask-busy-spinner size="1"></rask-busy-spinner>
        }&nbsp;Laddar Field Maps...
    </div>
    }

    <div class="radio-group">
        <rask-radiobutton-group
            [(ngModel)]="radioGruppValue"
            (change)=radiobuttonChanged($event)
            [buttons]="radioImportValues"
            [disabled]="disableRadioGrupp()">
        </rask-radiobutton-group>
        @if (isSelecting()) {
        <div class="container">
            <rask-validation-message-row
                type="info"
                message="Tryck och håll nere vänster musknapp för att markera ett område för import.">
            </rask-validation-message-row>
        </div>
        }
    </div>

    @if (isMapfileimport()) {
    <rask-file-upload
        accept=".zip"
        (fileChange)="onFileChange(upload.files)"
        (click)="onFileSelectClick()"
        #upload
        containerClass="btn btn-primary container">
        Välj filer
    </rask-file-upload>
    } @else {
    <rask-button
        [disabled]="isSelecting()"
        (click)="clickStartSelect()">
        Använd lasso</rask-button>
    }
</div>
}